import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { DistanceToFlagshipStore } from "../DistanceToFlagshipStore";

type IProps = Immutable<templates.DistanceToFlagshipStoreTemplate>;

export const DistanceToFlagshipStoreSSR = (
    _props: IProps,
): React.JSX.Element => {
    return <DistanceToFlagshipStore />;
};
